import { Avatar, Box, Button, Grid, IconButton, Modal, Slide, Typography,Skeleton} from "@mui/material"
import { CstmTextField } from "../../../../../../core/global/forms/CstmTextField";
import { ArrowLeft } from "../../../../../../core/global/Icons";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { rqx } from "../../../../../../core/request/API";
import { env } from "../../../../../../core/Env";
import { ToolContext } from "../../../../../../core/context/ToolContext";

export const View = ({ SendFeatureLogs, __SESSION, uai_user, cModal, setCModal }) => {
    const { speakout_state, } = useContext(ToolContext)
    const { message, successOpen } = speakout_state
    const [isLoading, setIsLoading] = useState(true)

    useEffect(()=>{
        const timer = setTimeout(() => setIsLoading(false), 2000);
            return () => clearTimeout(timer);
        },)
    const handleCloseView = async() => {
        await setCModal({...cModal, view: false, data: [], feedback: []})
    }
    const concernInfo = [
        {name: 'Category: ', val: cModal.data[0].speakout_category},
        {name: 'Receiver: ', val: cModal.data[0].speakout_team},
        {name: 'Type: ', val: cModal.data[0].type === 1 ? 'Suggestion/Recommendation' : 'Concern'},
        {name: 'Status: ', val: cModal.data[0].status === 1 ? 'Received' : ''},
        {name: 'Date: ', val: moment(cModal.data[0].created_at).format("MMMM DD, YYYY h:mm A")},
    ]

    const [concernFeedback, setConcernFeedback] = useState({
        company_speakout_id: '',
        feedback: '',
    })

    const handleInputFeedback = (e, val) => {  
        const { name } = e.target
        const value = val && val.id ? val.id : val || ''
        setConcernFeedback((prev) => ({
            ...prev, [name]: value
        }))
    }

    const handleSaveFeedback = async() => {
        let body = {...concernFeedback, company_speakout_id: cModal.data[0].id , user_id:atob(__SESSION.data.ainfo.aid).split('_', 2)[1]}
        let res = await rqx.post(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/concern/feedback`, body)
        if (res.message === 'success') {
            SendFeatureLogs(1)
            let fdata = [{feedback: body.feedback, date: new Date()}]
            successOpen.set(true)
            message.set('Feedback successfully saved.')
            setConcernFeedback({
                feedback: '',
            })
            setCModal((prev) => ({...prev, feedback: fdata}))
        }
    }

    const __init = async() => {
        let res = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/concern/readfeedback`, {
            company_speakout_id: cModal.data[0].id
        })
        let fdata = res
        setCModal((prev) => ({...prev, feedback: fdata}))
    }

    useEffect(() => {
        __init()
        //eslint-disable-next-line
    }, [])

    return (
        <Modal open={cModal.view} >
            <Slide in={cModal.view} direction="left" className="noutlined">
                    <Box height='100%' bgcolor="#FFFFFF"  >
                        {
                            cModal.data.map((v,k) => (
                            <Box key={k} height='100%' width="100%" bgcolor="#FFFFFF" display="flex" flexDirection="column" >
                                    <Box minHeight="44px" p="12px 16px" display="flex" alignItems="center" justifyContent='space-between'>  
                                        <Box>
                                            <IconButton sx={{p: '0px'}} onClick={() => handleCloseView()}>
                                                <ArrowLeft stroke="#313131" width={16} height={16} />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                    <Box> 
                                        <Typography fontSize="16px" fontWeight={600} lineHeight="26px" p="10px 0px 0px 10px">Concern Details</Typography>
                                            <Grid container>
                                                {
                                                    concernInfo.map((v,k) => (
                                                        <Box key={k} display="flex" flexDirection="row" px={2} py={1} width="100%">
                                                            <Grid item xs={4}> <Box fontSize="14px" fontWeight={400} color="#737373" >{v.name}</Box></Grid>
                                                            <Grid item xs={8}>
                                                                { isLoading? 
                                                                <Skeleton variant="rectangle" width="100%"/> 
                                                                : 
                                                                <Box sx={{ fontSize:'14px', justifyItems:'left'}} fontWeight={500}>{v.val}</Box> 
                                                                }
                                                            </Grid>
                                                        </Box>
                                                        ))
                                                }
                                            </Grid>
                                                <Box display="block" flexDirection="row"  m='10px'> 
                                                    <Box fontSize="14px" color="#737373" >Details:</Box> 
                                                        { isLoading? 
                                                            <Skeleton variant="rectangle" width="100%"/> 
                                                            :
                                                            <Box fontSize="14px" fontWeight={500} mb={1} justifyContent={'center'}>{v.details}</Box> 
                                                        }
                                                </Box>
                                                
                                            <Box height="100%" width="100%" borderTop="1px solid #0000001f"  m='10px'>
                                                <Box fontSize="14px" fontWeight={500}  my={1}>Feedback:</Box>
                                                    {
                                                        __SESSION.data.uaccess[0].role_id === parseInt(uai_user) && cModal.feedback.length === 0 &&
                                                        <Box fontSize="14px" fontWeight={500} my={3} display="flex" justifyContent="center">No Feedback yet.</Box>
                                                    }
                                                
                                                    {
                                                        __SESSION.data.uaccess[0].role_id !== parseInt(uai_user) && cModal.feedback.length === 0 &&
                                                        <Box  m='10px 20px 0px 0px' p='5px'>
                                                            <CstmTextField multiline rows={3} fullWidth name="feedback" placeholder="Add a Feedback" onChange={(e)=>handleInputFeedback(e, e.target.value)}></CstmTextField>
                                                            {
                                                                concernFeedback.feedback &&
                                                                    <Box sx={{display:'flex',justifyContent:'right'}}>
                                                                        <Button variant="contained" sx={{mt: '10px'}} onClick={() => handleSaveFeedback (v.id)}>Save</Button>
                                                                    </Box>
                                                            }
                                                        </Box>
                                                    }
                                                {
                                                    cModal.feedback.length !== 0  &&
                                                        <Box display="flex" flexDirection="column" mt={2} mb={3}>
                                                            <Box display="flex" flexDirection="row" alignItems="center" fontSize="14px" fontWeight={500}>
                                                                <Avatar alt="profile" sx={{width: 32, height: 32}} />
                                                                <Box ml={2}>Admin</Box>
                                                                <Box width="5px" height="5px" mx={1} borderRadius="0.5em" bgcolor="#EBEBEB"></Box>
                                                                <Box>{moment(cModal.feedback[0].date).format("MMMM DD, YYYY h:mm A")}</Box>
                                                            </Box>
                                                            <Box fontSize="14px" fontWeight={400} ml={10} mr={2} p='10px'  borderRadius={2}>{cModal.feedback[0].feedback}</Box>
                                                        </Box>
                                                }
                                            </Box>
                                    </Box>
                            </Box> 
                            ))
                        }
                    </Box>    
            </Slide>
        </Modal>
    )
}